module.exports = "<ion-content>\n  <app-grid-alert [alertReport]='alert' [search]='searchInput' *ngIf=\"view=='grid'\"></app-grid-alert>\n</ion-content>"